import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';

// Components

import AgentPromotion from '@components/individualPortal/AgentPromotion';
import SideNavContainer from './navigation/SideNavContainer';
import WelcomeUser from '@components/individualPortal/dashboard/WelcomeUser';
import Announcements from '@components/individualPortal/dashboard/announcements';

// ActionCreators
import { getTickets } from '@actions/individualPortal/ticket/ticketActionCreators';
import { showModal } from '@actions/common/actionCreators';
import { verifyAccessCode } from '@actions/individualPortal/dashboard/dashboardActionCreators';
import { fetchUnreadNotificationCount } from '@actions/individualPortal/secureInbox/secureInboxActionCreators';

// Utils
import { extractUserName } from '@utils/miscellaneous/extractUserName';

// Constants
import { configs } from '@constants/configs/configs';

const IndividualPortalContainer = (props) => {
    const {
        environment
    } = props;

    const {
        routes: {
            DELEGATION_CONSUMER,
        }
    } = configs;
    const location = useLocation();
    const userName = extractUserName(environment);
    const isDelegationPage = location.pathname === DELEGATION_CONSUMER;

    return (
        <main className="usa-layout-docs usa-section gi-main-section" id="individual-portal">
            <div className="grid-container gi-grid-container">
                <div className={`grid-row grid-gap gi-wrapper ${isDelegationPage && 'gi-wrapper-delegations'}`}>
                    <Fragment>
                        <div className="grid-col-12">
                            <WelcomeUser userName={userName} />
                        </div>
                        <div className="grid-col-12">
                            <Announcements />
                        </div>
                        <aside className="desktop:grid-col-3" id="side-nav">
                            <SideNavContainer {...props} />
                        </aside>
                        <div className="desktop:grid-col-9" id="main-content">
                            <Outlet/>
                        </div>
                    </Fragment>
                </div>
            </div>
            <AgentPromotion />
        </main>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment
});
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        verifyAccessCode,
        showModal,
        getTickets,
        fetchUnreadNotificationCount
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(IndividualPortalContainer);
